import React from 'react';
import { TypographyProps, Theme, Typography } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { TypographyColor } from '../types';

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      margin: theme.spacing(1),
    },
  });
};

export interface TypographyComponentProps
  extends WithStyles<TypographyProps & typeof styles> {
  children: React.ReactNode;
  variant: any;
  component?: any;
  className?: string;
  style?: any;
  color?: TypographyColor;
}

export const TypographyComponent: React.FC<TypographyComponentProps> = ({
  classes,
  children,
  variant,
  component,
  className,
  style,
  color,
  ...otherProps
}: TypographyComponentProps) => {
  return (
    <Typography
      variant={variant}
      component={component}
      className={className}
      color={color}
      style={style}
    >
      {children}
    </Typography>
  );
};

export default withStyles(styles)(TypographyComponent);
